module.exports = __webpack_public_path__ + "img/fuxuankuang2.9c01e710.svg";